import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LoadingWrapper } from 'barnyard/components';
import { Row, Col } from 'barnyard/layouts';
import { localStorageHelper } from 'barnyard/utils';
import { FINISHED_URL, LOCAL_STORAGE_VENDOR_FORM } from '../constants';
import { clearLocalStorages } from '../forms/utils';
import UpdateVendorWrapper from './UpdateVendorWrapper';
import MerchantSignupConfirm, { isProfileReady } from './MerchantSignupConfirm';

const classNamePrefix = 'Signup--FormPage';

class UpdateVendorView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vendorForm: localStorageHelper.retrieveJson(LOCAL_STORAGE_VENDOR_FORM),
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    const { vendor: prevVendor } = prevProps;
    const { vendor, location } = this.props;

    if (!vendor.isError && prevVendor.isUpdating === true && vendor.isUpdating === false) {
      // Made it through the signup flow, let's clean up and redirect to the seller portal
      clearLocalStorages();
      window.location = location.query.next || FINISHED_URL;
    }
  }

  render() {
    const {
      vendorUpdateAction,
      vendor,
      profile,
    } = this.props;
    const { vendorForm } = this.state;
    const isFormBlocked = vendor.isLoading || !isProfileReady(profile);

    return (
      <>
        <MerchantSignupConfirm profile={profile} />
        <div className={classNamePrefix}>
          <LoadingWrapper loading={isFormBlocked}>
            <Row align='middle' justify='center'>
              <Col className={`${classNamePrefix}__title`} span={12}>
                <h2>Let&apos;s Learn About Your Business!</h2>
              </Col>
              <Col span={12}>
                <UpdateVendorWrapper
                  onFormChange={values => localStorageHelper.saveJson(LOCAL_STORAGE_VENDOR_FORM, values)}
                  initialValues={vendorForm}
                  vendorUpdateAction={vendorUpdateAction}
                />
              </Col>
            </Row>
          </LoadingWrapper>
        </div>
      </>
    );
  }
}

UpdateVendorView.propTypes = {
  profile: PropTypes.object.isRequired,
  vendor: PropTypes.object.isRequired,
  vendorUpdateAction: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default UpdateVendorView;
